import walk from "./walk";

var isAllWhitespace = function isAllWhitespace(node) {
  var isTextNode = node.nodeType === Node.TEXT_NODE;
  var isWhitespace = !/[^\t\n\r ]/.test(node.textContent);
  return isTextNode && isWhitespace;
};
/**
 * `filterWhitespaceNodes` will remove any whitespace markup contained within the passed `Node`
 *
 * @param rootDOMNode the domNode
 */


export default function filterWhitespaceNodes(domNode) {
  return walk(domNode, function (node) {
    if (isAllWhitespace(node)) {
      node.parentNode.removeChild(node);
    }
  });
}